import _ from 'lodash';
import { parseVideoSdkUcCode } from '@/plans/VIDEO_SDK_UC/helper/parse';

export default (planList) => {
  return planList.forEach((item) => {
    const { plan_code, quantity } = parseVideoSdkUcCode(item.plan_code);
    item.plan_code = plan_code;
    item.cartInfo && quantity && (item.cartInfo.selected_number = _.parseInt(quantity));
  });
}
